import request from '@/utils/request'

// api地址
const api = {
  page: '/sys/dictdata/page'
}

/**
 * 查询列表
 * @param params 参数
 * @returns {Promise<Array>}
 */
export function pointType() {
  return new Promise((resolve, reject) => {
    const params = { dictCode: 'pointType' }
    request.get(api.page, { params: params }).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}
